import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'

import { isRole } from 'Global/Helpers/userHelpers'
import { hasTrueValues } from 'Global/Helpers/objectHelpers'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'MainModuleEnhancer'

    static propTypes = {
      currentIndex: PropTypes.number.isRequired,
      currentPicture: PropTypes.string.isRequired,
      currentRug: PropTypes.object.isRequired,
      errors: PropTypes.object.isRequired,
      getRecent: PropTypes.func.isRequired,
      getRecentMarkedForDesigners: PropTypes.func.isRequired,
      getRecentOrders: PropTypes.func.isRequired,
      getStatistics: PropTypes.func.isRequired,
      nextPicture: PropTypes.bool.isRequired,
      pendings: PropTypes.object.isRequired,
      previewExpanded: PropTypes.bool.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      previousPicture: PropTypes.bool.isRequired,
      recent: PropTypes.array.isRequired,
      recentMarkedForDesigners: PropTypes.array.isRequired,
      recentOrders: PropTypes.array.isRequired,
      redirectToSearch: PropTypes.func.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      statistics: PropTypes.object.isRequired,
      togglePreview: PropTypes.func.isRequired,
      togglePreviewExpansion: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const {
        getRecent,
        getRecentMarkedForDesigners,
        getRecentOrders,
        getStatistics,
        recent,
        recentMarkedForDesigners,
        recentOrders,
        redirectToSearch,
        statistics,
        user,
      } = this.props

      redirectToSearch()

      const isDesigner = isRole(user, 'designer')

      if (isEmpty(recentOrders) && (isRole(user, 'advisor') && !isDesigner)) {
        const advisor = `${user.firstName} ${user.lastName}`

        getRecentOrders(advisor, user.additionalAdvisors)
      }

      if (isEmpty(recentMarkedForDesigners) && isDesigner) {
        getRecentMarkedForDesigners()
      }

      if (isEmpty(recent)) {
        getRecent()
      }

      if (isEmpty(statistics)) {
        getStatistics()
      }
    }

    render() {
      return (
        <WrappedComponent
          currentIndex={this.props.currentIndex}
          currentPicture={this.props.currentPicture}
          currentRug={this.props.currentRug}
          errors={this.props.errors}
          getRecent={this.props.getRecent}
          getRecentMarkedForDesigners={this.props.getRecentMarkedForDesigners}
          getRecentOrders={this.props.getRecentOrders}
          getStatistics={this.props.getStatistics}
          hasError={hasTrueValues(this.props.errors)}
          loaderPending={!hasTrueValues(this.errors) && hasTrueValues(this.props.pendings)}
          nextPicture={this.props.nextPicture}
          pendings={this.props.pendings}
          previewExpanded={this.props.previewExpanded}
          previewOpen={this.props.previewOpen}
          previousPicture={this.props.previousPicture}
          recent={this.props.recent}
          recentMarkedForDesigners={this.props.recentMarkedForDesigners}
          recentOrders={this.props.recentOrders}
          setCurrentIndex={this.props.setCurrentIndex}
          statistics={this.props.statistics}
          togglePreview={this.props.togglePreview}
          togglePreviewExpansion={this.props.togglePreviewExpansion}
          user={this.props.user}
        />
      )
    }
  }

  return Container
}
